module.exports = "/images/to.svg?48fe9b705a388343029487e7d648f934";